import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Table, Tooltip, Typography } from 'antd';
import { useState } from 'react';
import { useAuditLogs } from '../api/hooks';
import type { AuditLog } from '../api/types';
import { formatDateTime, toJsonText } from '../utils/format';

const { Title, Text } = Typography;

export default function LogsPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const list = useAuditLogs(page, pageSize);

  const columns = [
    {
      title: 'Thời gian',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: (v: string) => formatDateTime(v),
    },
    { title: 'Người thực hiện', dataIndex: 'actor', key: 'actor', width: 160 },
    { title: 'Hành động', dataIndex: 'action', key: 'action' },
    {
      title: 'IP',
      dataIndex: 'ip',
      key: 'ip',
      width: 140,
      render: (v: string) => v || '—',
    },
    {
      title: 'Chi tiết',
      dataIndex: 'detail',
      key: 'detail',
      ellipsis: true,
      render: (v: unknown) => {
        if (v === undefined || v === null) return '—';
        const txt = toJsonText(v);
        return (
          <Tooltip title={<pre style={{ margin: 0 }}>{txt}</pre>}>
            <Text code style={{ fontSize: 12 }}>
              {txt.length > 60 ? `${txt.slice(0, 60)}...` : txt}
            </Text>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <div>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>
          Nhật ký (Audit logs)
        </Title>
        <Button icon={<ReloadOutlined />} onClick={() => list.refetch()}>
          Làm mới
        </Button>
      </Space>

      <Table<AuditLog>
        rowKey={(r) => r.id ?? `${r.actor}-${r.createdAt}`}
        loading={list.isLoading}
        dataSource={list.data?.items ?? []}
        columns={columns}
        pagination={{
          current: page,
          pageSize,
          total: list.data?.total ?? 0,
          showSizeChanger: true,
          onChange: (p, ps) => {
            setPage(p);
            setPageSize(ps);
          },
        }}
      />
    </div>
  );
}
